module.exports = __webpack_public_path__ + "img/content-block-sm-personal-voice_2x.205aeb1b.png";